module.exports = __webpack_public_path__ + "static/media/img1-1.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/nutricheck_foliar/ZN/img1-1.png
// module id = 2320
// module chunks = 3